import axios from 'axios'

var API_URL = process.env.VUE_APP_URL + '/api/pedidos/'
class PedidosService {
    // getItemsCarrito(id) {
    //   return axios.get(API_URL + 'itemsCarrito?id=' + id)
    // }
    getItemsCarritoCliente(id, idcli) {
      return axios.get(API_URL + 'itemsCarrito/cliente?id=' + id + (idcli ? '&idcli=' + idcli : ''))
    }
    getItemsCarritoClienteSimple(id, idcli) {
      return axios.get(API_URL + 'itemsCarrito/cliente/simple?id=' + id + (idcli ? '&idcli=' + idcli : ''))
    }

    getExcelCarrito(idusu, idcli) {
      return axios.get(API_URL + 'itemsCarrito/carrito-excel?idusu=' + idusu + (idcli ? '&idcli=' + idcli : ''), { responseType: 'arraybuffer' })
    }

    getExcelEjemplo() {
      return axios.get(API_URL + 'itemsCarrito/ejemplo', { responseType: 'arraybuffer' })
    }
    
    getCountItemsCarrito(id) {
      return axios.get(API_URL + 'itemsCarrito/cantidad?id=' + id)
    }
    getCountItemsCarritoCliente(id, idcli) {
      return axios.get(API_URL + 'itemsCarrito/cantidad?id=' + id + (idcli ? '&idcli=' + idcli : ''))
    }

    postItemsCarrito(item) {
      return axios.post(API_URL + 'itemsCarrito', item)
    }

    deleteItemCarrito(id) {
      return axios.delete(API_URL + 'itemsCarrito/' + id)
    }

    deleteCarritoUsuCli(idusu, idcli) {
      return axios.delete(API_URL + 'itemsCarrito/' + idusu + '/' + (idcli ? idcli : -1))
    }

    deleteCarritoCliente() {
      return axios.delete(API_URL + 'itemsCarrito/all')
    }

    importarPedido(pedidos) {
      return axios.post(API_URL + 'itemsCarrito/importar-pedido', pedidos)
    }

    getJobStatus(jobId) {
      return axios.get(API_URL + 'itemsCarrito/importar-pedido/status/' + jobId)
    }

    getAllCategorias() {
      return axios.get(API_URL + 'categorias')
    }

    getCategorias() {
      return axios.get(API_URL + 'categorias/art')
    }

    nuevaCategoria(itm) {
      return axios.post(API_URL + 'categorias', itm)
    }

    editarCategoria(id, nombre) {
      return axios.put(API_URL + 'categorias?id=' + id + '&nombre=' + nombre)
    }

    borrarCategoria(id) {
      return axios.delete(API_URL + 'categorias?id=' + id)
    }

    
    getMarcas() {
      return axios.get(API_URL + 'categorias/marcas')
    }

    nuevaMarca(nombre) {
      return axios.post(API_URL + 'categorias/marca?nombre=' + nombre)
    }

    cambiarOrden(id, orden) {
      return axios.put(API_URL + 'categorias/orden?id=' + id + '&orden=' + orden)
    }
    cambiarOrdenSubcat(subcats) {
      return axios.put(API_URL + 'categorias/orden/subcats', subcats)
    }
    cambiarOrdenCat(cats) {
      return axios.put(API_URL + 'categorias/orden/cats', cats)
    }

    getAllProductos() {
      return axios.get(API_URL + 'productos/all')
    }

    getAllProductosSubcat(idmarca, idcat, idsubcat) {
      return axios.get(API_URL + 'productos/subcat?m=' + idmarca + '&c=' + idcat + (idsubcat ? ('&s=' + idsubcat) : ''))
    }

    editarOrdenArticulos(articulos) {
      return axios.put(API_URL + 'productos/subcat', articulos)
    }

    getProductoCodigo(code) {
      return axios.get(API_URL + 'productos/code?code=' + code)
    }

    getProductoCodigoBatch(lista) {
      return axios.put(API_URL + 'productos/code', lista)
    }

    getProductosConIndex(index) {
      return axios.get(API_URL + 'productos?index=' + index)
    }

    getProductosConIndexBusqueda(index, texto) {
      return axios.get(API_URL + 'productos/buscador?index=' + index + '&t=' + texto)
    }

    getProductosConIndexRango(index, desde, hasta) {
      return axios.get(API_URL + 'productos/rango?index=' + index + '&d=' + desde + '&h=' + hasta)
    }

    getProductosConIndexOrdenPrecio(index, masamenos) {
      return axios.get(API_URL + 'productos/ordenPrecio?index=' + index + '&o=' + masamenos)
    }

    getProductosConIndexCategoria(index, id, idcat, idsub) {
      return axios.get(API_URL + 'productos/categoria?index=' + index + '&m=' + id + '&c=' + idcat + '&s=' + idsub)
    }

    getProductosFiltro(num, n, m, c, s, a, p) {
      return axios.get(API_URL + 'productos/filtro' + (num ? '?index=' + num : '') +
       (n ? '&n=' + n : '') + 
       (m ? '&m=' + m : '') + 
       (c ? '&c=' + c : '') +
       (s ? '&s=' + s : '') +
       ((a && c != 99) ? '&a=' + a : '') + 
       (p ? '&p=' + p : ''))
    }

    getProductoExacto(num) {
      return axios.get(API_URL + 'productos/exacto?num=' + num)
    }

    getProductosFiltrados(num, n, m, c, s, p, min, max) {
      return axios.get(API_URL + 'productos/filtros' + (num ? '?index=' + num : '') +
       (n ? '&n=' + n : '') + 
       (m ? '&m=' + m : '') + 
       (c ? '&c=' + c : '') +
       (s ? '&s=' + s : '') +
       (p ? '&p=' + p : '') +
       (min ? '&min=' + min : '') +
       (max ? '&max=' + max : ''))
    }

    getImagenProducto(idart, numImg) {
      return axios.get(API_URL + 'productos/imagen/' + idart + '?numImg=' + numImg, {
        responseType: 'arraybuffer'
      })
    }

    deleteImagenProducto(idio, nro) {
      return axios.delete(API_URL + 'productos/imagen' + '?idio=' + idio + '&nro=' + nro)
    }

    postImagenProducto(idio, nro, formData) {
      return axios.post(API_URL + 'productos/imagen' + '?idio=' + idio + '&nro=' + nro, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }

    postVideoProducto(idio, nro, formData) {
      return axios.post(API_URL + 'productos/video' + '?idio=' + idio + '&nro=' + nro, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }

    putItemOrden(id, item) {
      return axios.put(API_URL + 'productos/item/' + id, item)
    }

    postItemOrden(item) {
      return axios.post(API_URL + 'productos/item', item)
    }

    crearPedido(idcli, dir, obs, cond) {
      return axios.post(API_URL + 'productos/pedido?' + (idcli ? ('idcli=' + idcli + '&') : '') + 'dir=' + dir + '&obs=' + obs + '&cond=' + cond)
    }

    cargarCarritosUsuarios() {
      return axios.get(API_URL + 'itemsCarrito/all')
    }
    cargarPedidosHistoricos(index, cli) {
      return axios.get(API_URL + 'productos/pedidos/historicos?index='+ index + (cli ? ('&cli=' + cli) : ''))
    }
    devolverCarrito(idusu, idcli) {
      return axios.post(API_URL + 'itemsCarrito/devolver-carrito?idusu=' + idusu + (idcli ? ('&idcli=' + idcli) : ''))
    }
    getMisPedidos(index) {
      return axios.get(API_URL + 'productos/pedidos?index=' + index)
    }

    getPedidosUsuario(id) {
      return axios.get(API_URL + 'productos/pedidos/' + id)
    }

    getPedidosUsuariosNuevos() {
      return axios.get(API_URL + 'productos/pedidos/nuevos')
    }

    getProductosNoAsignados() {
      return axios.get(API_URL + 'productos/no-asignados')
    }

    generarCatalogo(logo, img, prc, m, c, s) {
      return axios.get(API_URL + 'productos/catalogo?logo='+logo+'&img=' +img+'&prc='+prc+ (m ? ('&m='+m) : '') + (c ? ('&c='+c) : '') + (s ? ('&s='+s) : ''), {
        responseType: 'blob'
      })
    }
    
    generarCertificado(idart) {
      return axios.get(API_URL + 'productos/certificados?idart='+idart, {
        responseType: 'blob'
      })
    }
    
    subirCertificado(cert) {
      return axios.post(API_URL + 'productos/certificados', cert, {
        headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
    }

    getAllCertificados() {
      return axios.get(API_URL + 'productos/certificados/all')
    }

    getCertificadoNombre(nombre) {
      return axios.get(API_URL + 'productos/certificados/buscar?nombreArchivo=' + nombre, {
        responseType: 'blob'
      })
    }

    generarExcel(logo, img, prc, m, c, s) {
      return axios.get(API_URL + 'productos/excel?logo='+logo+'&img=' +img+'&prc='+prc+ (m ? ('&m='+m) : '') + (c ? ('&c='+c) : '') + (s ? ('&s='+s) : ''), {
        responseType: 'blob'
      })
    }

    generarExcelQuotation(idarts) {
      const idString = idarts.join(',');
      return axios.post(API_URL + 'itemsCarrito/catalogo-quotation', idString, {
        headers: {
          'Content-Type': 'text/plain'
        },
        responseType: 'blob'
      });
    }
    generarPdfQuotation(idarts) {
      const idString = idarts.join(',');
      return axios.post(API_URL + 'itemsCarrito/catalogo-quotation-pdf', idString, {
        headers: {
          'Content-Type': 'text/plain'
        },
        responseType: 'blob'
      });
    }
    generarCatalogoCustom(idusu, idcli, prc) {
      return axios.get(API_URL + 'productos/catalogo-custom?idusu='+idusu + (idcli ? ('&idcli=' + idcli) : '') + '&prc='+prc, {
        responseType: 'blob'
      })
    }
    generarListaPrecios(id) {
      return axios.get(API_URL + 'productos/lista-precios?id='+id, {
        responseType: 'blob'
      })
    }
}

export default new PedidosService()